<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px;height:  auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav class="align-items-center">
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>
              <md-text>Back</md-text>
            </b-button>
          
          <b-navbar-brand center>To Do List</b-navbar-brand>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button @click="goToMain" size="sm" variant="warning">New Task</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard" v-if="showMain==true">
          <b-card-text>
            <div v-if="showMain==true">
            
                <div class="row mt-2">
                  <div class="col-md-3">
                    <label>Task Title</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="showStatus==false?false:true"
                      id="taskTitle"
                      name="taskTitle"
                      v-model="agentColaderModel.taskTitle"
                    ></b-form-input>
                  </div>
                  <div class="col-md-3">
                    <label>Client</label>        
                    <model-list-select
                      @input="getAssignmentData()"
                      :list="clientMaster"
                      :isDisabled="showStatus==false?false:true"
                      option-value="clientId"
                      option-text="clientName"
                      id="clientId"
                      name="clientName"
                      placeholder="Select Client"
                      v-model="agentColaderModel.fk_client_id"
                    ></model-list-select>
                  </div>
                  <div class="col-md-3">
                    <label>POD</label>
                    <model-list-select
                      @input="getLocationList($event, 'All', 'PODList');getAssignmentData()"
                      @searchchange="getLocationList($event, 'All', 'PODList');"
                      :list="PODList"
                      :isDisabled="showStatus==false?false:true"
                      option-value="pickupId"
                      option-text="pickupLocation"
                      id="pickupId"
                      name="pickupLocation"
                      placeholder="Select POD"
                      v-model="agentColaderModel.fk_pod_id"
                    ></model-list-select>
                  </div>
                  <div class="col-md-3">
                    <label>Assignment No.</label>
                    <model-list-select
                      :list="AssignmentArrList"
                      :isDisabled="showStatus==false?false:true"
                      option-value="allModuleId"
                      option-text="mainSalesSeries"
                      id="allModuleId"
                      name="mainSalesSeries"
                      placeholder="Select Assignment No."
                      v-model="agentColaderModel.fk_all_module_id"
                    ></model-list-select>
                  </div>
                  <div class="col-md-3">
                    <label>Assign To</label>
                    <multi-list-select
                      :list="userDataList"
                      :isDisabled="showStatus==false?false:true"
                      option-value="userId"
                      option-text="employeeName"
                      id="mySelectId"
                      name="mySelectName"
                      :selected-items="itemsUsers"
                      placeholder="select "
                      @select="onSelect"
                    ></multi-list-select>
                  </div>
                  <div class="col-md-9">
                    <label>Description</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      :Disabled="showStatus==false?false:true"
                      id="taskDescription"
                      name="taskDescription"
                      v-model="agentColaderModel.taskDescription"
                    ></b-form-textarea>
                    <label
                      v-if="agentColaderModel.taskStatus=='2' || agentColaderModel.taskStatus=='3'"
                    >Remarks & Quries</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      v-if="agentColaderModel.taskStatus=='2' || agentColaderModel.taskStatus=='3'"
                      id="taskDescription1"
                      name="taskDescription1"
                      v-model="agentColaderModel.taskRemarks"
                    ></b-form-textarea>
                   
                    
                    <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                  </div>
                  <div class="col-md-6">
                    <label for="blType" v-if="showStatus==true">Task Status</label>
                    <model-list-select
                      v-if="showStatus==true"
                      :list="categoryTypeList"
                      v-model="agentColaderModel.taskStatus"
                      option-value="categoryTypeVal"
                      option-text="categoryTypeTxt"
                      placeholder="Select Status"
                    ></model-list-select>
                    <div style="-webkit-overflow-scrolling: auto;"
                      v-if="descriptionList.length>0"
                      class="box box-warning direct-chat direct-chat-warning"
                    >
                      <div class="box-header with-border"></div>
                      <!-- /.box-header -->
                      <div class="box-body" style="border:1px solid black">
                        <!-- Conversations are loaded here -->
                        <div class="direct-chat-messages" id="descriptionList">
                          <ul
                            style="padding:0;margin:0"
                            v-for="(item,index) in descriptionList"
                            :key="index"
                          >
                            <div v-if="item.description!=''">
                              <div class="direct-chat-msg mt-2">
                                <div class="direct-chat-info clearfix">
                                  <span class="direct-chat-name pull-left">{{item.employeeName}}</span>
                                  <span
                                    class="direct-chat-timestamp pull-right"
                                  >{{item.loginTime | moment}}</span>
                                </div>
                                <!-- /.direct-chat-info -->
                                <span
                        class="img-sm rounded-circle bg-primary text-white text-center text-avatar"
                        >{{ item.employeeName.slice(0, 1) }}</span
                      >
                                <!-- /.direct-chat-img -->
                                <div class="direct-chat-text">{{item.description}}</div>
                                <hr>
                                <!-- /.direct-chat-text -->
                              </div>
                            </div>
                            <div v-if="descriptionList.length<=0 && item.description==''">
                              <span
                                class="direct-chat-name error text-muted"
                              >Remarks & Queries will appear here if any.
                                <hr>
                              </span>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                     <div class="text-center mt-3">
                      <b-button
                      variant="primary"
                      @click="addTask"
                      id="addButtonLoader"
                    >{{agentColaderModel.taskId!=''?'Update':'Add'}} Task</b-button>
                    </div>
                  </div>
                </div>
            

              <!-- <md-layout md-gutter class="mrgtop-button mt-4">
                <md-layout md-flex="5"></md-layout>
                
              </md-layout>-->
            </div>
          </b-card-text>
        </b-card>

        <!-- User Interface controls -->
        
        <div class="mt-2">
          <b-form-group>
            <b-input-group>
              <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search" class="form-focus"/>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="80"></md-layout> -->

          <md-layout md-flex="20">
            <model-list-select
              @input="getData"
              :list="payList"
              v-model="donePendingFilter"
              option-value="payVal"
              option-text="payText"
              placeholder="Select "
            ></model-list-select>
          </md-layout>
          <md-layout class="justify-content-end">
            <h5 class="text-muted pull-right">
              <small>{{totalRows}} Entries</small>
            </h5>
         </md-layout>
        </md-layout>
        <!-- Main table element -->
        <div class="table-responsive tableMain mt-2">
          <b-table
            show-empty
            stacked="md"
            :items="taskDataList"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="taskId" slot-scope="row0">
              <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="taskTitle" slot-scope="row1">
              <b
                :style="row1.item.firstSeenByUserId=='0'?'color:red':''"
                v-if="row1.item.taskStatus!='2'"
                @click="viewEdit(row1.item)"
                class="showMoreData"
              >{{row1.item.taskTitle}}</b>
              <b v-else>{{row1.item.taskTitle}}</b>
              <b-badge variant="danger" v-if="row1.item.firstSeenByUserId=='0'">not seen</b-badge>
              <br>
              <span>
                Created By {{row1.item.employeeName}}
                <br>
              </span>
              <span>On {{row1.item.loginTime | moment}}</span>
            </template>

            <!-- <template slot="employeeName" slot-scope="row1">
              <span>
                {{row1.item.employeeName}}
                <br>
              </span>
              <span>{{row1.item.loginTime}}</span>
            </template>-->
            <template slot="taskStatus" slot-scope="row11">
              <b-badge>{{(row11.item.taskStatus=='0')?'Pending':row11.item.taskStatus=='1'?'In-Progress':row11.item.taskStatus=='2'?'Completed':'Query Raised'}}</b-badge>
              <br>
              <span style="color:blue" v-if="row11.item.firstSeenByUserId!='0'">
                Task Seen on {{row11.item.firstSeenByUserDate | moment}}
                <br>
              </span>
              
              <span v-if="row11.item.lastUpdatedBy!='' && row11.item.lastUpdatedBy!=null">
                Last Updated By {{row11.item.lastUpdatedBy}}
                <br>
                on {{row11.item.updateTime | moment}}
              </span>
            </template>
            <template slot="assignedUsersName" slot-scope="row5">
              <div v-if="row5.item.assignedUsersName!=null">
                <span v-for="(item1,index) in row5.item.assignedUsersName.split(',')" :key="index">
                  <h6>
                    <b-badge variant="secondary">{{item1==''?'-------':item1}}</b-badge>
                  </h6>
                </span>
              </div>
            </template>
          </b-table>
        </div>

        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
limit="5"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              align="center"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import {
  ModelListSelect,
  MultiListSelect,
  MultiSelect
} from "vue-search-select";

// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus,GlobalGetLocation } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/toDoList/toDoList");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      descriptionList: [],
      donePendingFilter: "4",
      payList: [
        {
          payVal: "0",
          payText: "Pending"
        },
        // {
        //   payVal: "1",
        //   payText: "In-Progress"
        // },
        {
          payVal: "2",
          payText: "Completed"
        },
        {
          payVal: "3",
          payText: "Query"
        },
        {
          payVal: "4",
          payText: "All"
        }
      ],
      fields: [
        {
          key: "taskId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "taskTitle",
          label: "Task Title",
          sortable: true,
          sortDirection: "desc"
        },
        // {
        //   key: "employeeName",
        //   label: " Created By",
        //   sortable: true,
        //   sortDirection: "desc"
        // },
        {
          key: "taskDescription",
          label: " Description",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "mainSalesSeries",
          label: " Assignment No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "POD",
          label: "POD.",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "assignedUsersName",
          label: "Assigned To",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "taskStatus",
          label: " Task Status",
          sortable: true,
          sortDirection: "desc"
        }
        // {
        //   key: "Remarks",
        //   label: " Remarks & Queries",
        //   sortable: true,
        //   sortDirection: "desc"
        // }
        // {
        //   key: "isTaskActive",
        //   label: "Action",
        //   sortable: true,
        //   sortDirection: "desc"
        // }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      showMain: false,
      showStatus: false,
      taskDataList: [],
      userDataList: [],
      AssignmentArrList:[],
      clientMaster:[],
      PODList:[],
      clientDataPersonal: [],
      agentColaderModel: {
        taskRemarks: "",
        assignedUsers: [],
        UsersDummy: [],
        lastSelectItem: {},
        taskStatus: "0",
        taskId: "",
        fk_pod_id:"",
        fk_client_id:"",
        fk_all_module_id:"",

        taskTitle: "",

        taskDescription: ""
      },
      addedByUser: "",
      addedByUserNotify: "",
      seenByUser: "",
      categoryTypeList: [
        {
          categoryTypeVal: "0",
          categoryTypeTxt: "Pending"
        },
        // {
        //   categoryTypeVal: "1",
        //   categoryTypeTxt: "In-Progress"
        // },
        {
          categoryTypeVal: "2",
          categoryTypeTxt: "Completed"
        },
        {
          categoryTypeVal: "3",
          categoryTypeTxt: "Raise Query"
        }
      ],
      isLoading: true,
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "New"
      },
      options: [
        { value: "1", text: "aa" + " - " + "1" },
        { value: "2", text: "ab" + " - " + "2" },
        { value: "3", text: "bc" + " - " + "3" },
        { value: "4", text: "cd" + " - " + "4" },
        { value: "5", text: "de" + " - " + "5" }
      ],
      searchText: "", // If value is falsy, reset searchText & searchItem
      itemsUsers: [],

      validate: true,
      categoryTypeError: ""
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY hh:mm:ss");
      //  return moment(date).fromNow();
    }
  },
  mounted() {
    //this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiListSelect,
    MultiSelect
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    getAssignmentData() {
      this.AssignmentArrList = [];
      let payload = {
        categoryType: "categoryType",
        pod_id: this.agentColaderModel.fk_pod_id,
        client_id: this.agentColaderModel.fk_client_id,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getAssignmentBasedonPODClient.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if(data.AssignmentArr.length>0){
              this.AssignmentArrList = data.AssignmentArr;
            }
          }
        })
        .catch(error => {});
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/mainEnquiry/viewMainEnqQuotationFF"
      // });
    },
    onSelect(items, lastSelectItem) {
      this.itemsUsers = items;
      this.agentColaderModel.lastSelectItem = lastSelectItem;
      this.agentColaderModel.assignedUsers = items;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      Object.keys(this.agentColaderModel).map(x => {
        this.agentColaderModel[x] = "";
      });
      this.itemsUsers = [];
      this.showStatus = false;
      this.descriptionList = [];
      this.agentColaderModel.assignedUsers = [];
      this.showMain = true;
    },
    viewEdit(item1) {
      if(item1.task_lead_type==2){
        this.$router.push({
        path: "/lead/leadlist",
      });
      }
      this.showMain = true;
      this.showStatus = false;
      if (item1.added_userId != this.clientDataPersonal[0].userId) {
        this.showStatus = true;
      }

      let arrayFilter = this.taskDataList.filter(x => {
        return x.taskId == item1.taskId;
      });
      if (arrayFilter.length > 0) {
        Object.keys(this.agentColaderModel).map(x => {
          this.agentColaderModel[x] = arrayFilter[0][x] || "";
        });
      }
      this.itemsUsers = [];
      this.agentColaderModel.assignedUsers = [];
      if (item1.assignedUsers != "" && item1.assignedUsers != null) {
        let userDummy = item1.assignedUsers.split(",");

        for (let q = 0; q < userDummy.length; q++) {
          let arryUserFilter = this.userDataList.filter(x => {
            return x.userId == userDummy[q];
          });
          if (arryUserFilter.length > 0) {
            this.itemsUsers.push(...arryUserFilter);
            this.agentColaderModel.assignedUsers.push(...arryUserFilter);
          }
        }
      }
      if (item1.firstSeenByUserId == "0") {
        this.addedByUser = item1.added_userId;
        this.seenByUser = item1.firstSeenByUserId;
      }
      this.addedByUserNotify = item1.added_userId;
      this.getData();
    },
    JqueryFun() {
      return $(function() {
        return $("#agentCo12").DataTable();
      });
    },
    onClose(type) {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //   });
    },
    previousVendorView() {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //     // params:{
      //     //   "userId":res.data.Id,
      //     // }
      //   });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.agentColaderModel.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addTask() {
      if (this.agentColaderModel.taskTitle == "") {
        this.alert.content = "Please Enter Task Title";
        this.$refs["addPop"].open();
        return false;
      }
      // alert(this.agentColaderModel.assignedUsers.length);
      // return false;

      if (this.agentColaderModel.assignedUsers.length<=0) {
        this.alert.content = "Please Enter Assign To User";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.agentColaderModel.taskStatus == "") {
        this.agentColaderModel.taskStatus = "0";
      }
      if(this.agentColaderModel !="" && this.agentColaderModel !=null && this.agentColaderModel!=undefined){
        this.agentColaderModel.msg_type=2;
      }else{
        this.agentColaderModel.msg_type=0;
      }

      this.agentColaderModel["addedByUserNotify"] = this.addedByUserNotify;
      // console.log("this.agentColaderModel=>",this.agentColaderModel);return false;
      //   this.validateRefuelStation();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/addTaskToUser.php`,
          data: JSON.stringify(this.agentColaderModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            if ((result.data.msg = "Inserted Successfully")) {
              Object.keys(this.agentColaderModel).map(x => {
                this.agentColaderModel[x] = "";
              });
              this.itemsUsers = [];
              //   this.agentColaderModel.assignedUsers = [];
            }

            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
            this.getData();
            this.showMain = false;
          })

          .catch(error => {});
      }
    },
    getData() {
      this.isLoading = true;
      this.taskDataList = [];
      let type_Size = {
        notification: "",
        donePendingFilter: this.donePendingFilter,
        categoryType: "categoryType",
        addedByUser: this.addedByUser,
        seenByUser: this.seenByUser,
        taskId: this.agentColaderModel.taskId
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataToDoList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.userDataList.length > 0) {
              this.userDataList = data.userDataList;
            }
            if(data.AssignmentArr.length>0){
              this.AssignmentArrList = data.AssignmentArr;
            }
            if(data.clientMaster.length>0){
              this.clientMaster = data.clientMaster
            }
            if(data.PODList.length>0){
              this.PODList = data.PODList
            }
            if (data.clientDataPersonal.length > 0) {
              this.clientDataPersonal = data.clientDataPersonal;
            }

            if (data.taskDataList.length > 0) {
              this.taskDataList = data.taskDataList;
              this.totalRows = data.taskDataList.length;
            }
            if (data.descriptionList.length > 0) {
              this.descriptionList = data.descriptionList;
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}

.form-focus:focus{
  box-shadow: none;
  border-color: #002b49;
}
</style>


// WEBPACK FOOTER //
// toDoList.vue?3b00d970